import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { getYMDHM } from '@src/utils';
import { type FeedFlowItem } from '@src/services/interface';

type NoticeProps = {
    content: {
        unlockTime?: FeedFlowItem['unlockTime'];
        isFeed: boolean;
    };
};

const Notice = ({ content }: NoticeProps) => {
    const isFeed = content.isFeed;
    const unlockTime = content.unlockTime || 0;
    const dateTime = getYMDHM(unlockTime);
    const year = dateTime?.year;
    const month = dateTime?.month;
    const date = dateTime?.date;
    const hours = dateTime?.hours;
    const minute = dateTime?.minute;
    const unlockTimeString = `${year}-${month}-${date} ${hours}:${minute}`;

    return unlockTime ? (
        <div className={isFeed ? styles.feedNotice : styles.articleNotice}>
            <div className={styles.notice}>
                <div className={styles.noticeIcon} />
                <div className={styles.noticeText}>{unlockTimeString}揭晓</div>
            </div>
        </div>
    ) : null;
};

export default errorBoundary(Notice);
